
export const ptomDetailAuthList = [
  {
    name: '基础数据',
    items: [
      { name: '投放计划名称', key: 'planName', checked: true, disabled: true },
      { name: '新建时间', key: 'launchTime', checked: true },
      { name: '投放媒体', key: 'mediaName', checked: true },
      { name: '投放游戏', key: 'productName', checked: true },
      { name: '投放账号', key: 'adAccountName', checked: true },
      { name: '账面消耗', key: 'paperUseAmount', checked: false },
      { name: '实际消耗', key: 'amount', checked: false },
      { name: '点击率', key: 'clickRate', checked: false },
      { name: '激活率', key: 'activeRate', checked: false },
      { name: '采集点击', key: 'collectClickNum', checked: false },
      { name: '下载率', key: 'downRate', checked: false },
      { name: '激活数', key: 'downNum', checked: false },
      { name: '注册数', key: 'newUserNum', checked: false },
      { name: '创角数', key: 'createRoleNum', checked: false },
      { name: '新建角色数', key: 'newRoleNum', checked: false },
      { name: '激活成本', key: 'activeCost', checked: false },
      { name: '创角成本', key: 'createRoleCost', checked: false },
      { name: '创角率', key: 'createRoleRate', checked: false }
    ]
  },
  {
    name: '付费数据',
    items: [
      { name: '新增付费创角数', key: 'payRoleUserNum', checked: false },
      { name: '付费创角成本', key: 'newPayCost', checked: false },
      { name: '当日新增付费设备', key: 'payActiveDeviceNum', checked: false },
      { name: '新创角充值金额', key: 'newRoleMoney', checked: false },
      { name: '新创角回款率', key: 'newRoleRate', checked: false },
      { name: '总流水', key: 'sumMoney', checked: false }
    ]
  },
  {
    name: '留存/LTV',
    items: [
      { name: '激活次留', key: 'nextDayRetainRate', checked: false },
      { name: '激活3留', key: 'threeDayRetainRate', checked: false },
      { name: '激活7留', key: 'sevenDayRetainRate', checked: false },
      { name: '激活30留', key: 'thirtyDayRetainRate', checked: false },
      { name: '激活1日LTV', key: 'oneDayLtv', checked: false },
      { name: '激活3日LTV', key: 'threeDayLtv', checked: false },
      { name: '激活7日LTV', key: 'sevenDayLtv', checked: false },
      { name: '激活30日LTV', key: 'thirtyDayLtv', checked: false }
    ]
  }
]

export const complexReportAuthList = [
  {
    name: '基础数据',
    items: [
      { name: '投放计划名称', key: 'planName', checked: true, disabled: true },
      { name: '新建时间', key: 'launchTime', checked: true },
      { name: '投放媒体', key: 'mediaName', checked: true },
      { name: '投放游戏', key: 'gameName', checked: true },
      { name: '投放账号', key: 'adAccountName', checked: true },
      { name: '账面消耗', key: 'paperConsume', checked: false },
      { name: '实际消耗', key: 'realConsume', checked: false },
      { name: '点击率', key: 'clickRate', checked: false },
      { name: '激活数', key: 'activeNum', checked: false },
      { name: '注册数', key: 'registerNum', checked: false },
      { name: '创角数', key: 'createRoleNum', checked: false },
      { name: '新建角色数', key: 'newRoleNum', checked: false },
      { name: '激活成本', key: 'activeCost', checked: false },
      { name: '创角成本', key: 'createRoleCost', checked: false },
      { name: '创角率', key: 'newRoleRate', checked: false },
      { name: '操作-用户', key: 'control', checked: false }
    ]
  },
  {
    name: '付费数据',
    items: [
      { name: '新增付费创角数', key: 'payRoleUserNum', checked: false },
      { name: '付费创角成本', key: 'newPayCost', checked: false },
      { name: '新创角充值金额', key: 'natureTimeNewRoleMoney', checked: false },
      { name: '新创角回款率', key: 'natureTimeNewRoleRoi', checked: false },
      { name: '创角24h付费金额', key: 'createRole24hPayMoney', checked: false },
      { name: '创角24hROI', key: 'createRole24hRoi', checked: false },
      { name: '总流水', key: 'totalMoney', checked: false }
    ]
  },

  {
    name: '中间件_再归因维度数据',
    items: [
      { name: '激活数（中间件）', key: 'miActiveNum', checked: false },
      { name: '注册数（中间件）', key: 'miRegisterNum', checked: false },
      { name: '创角数（中间件）', key: 'miCreateRoleNum', checked: false },
      { name: '创角成本（中间件）', key: 'miCreateRoleCost', checked: false },
      { name: '新增付费创角数（中间件）', key: 'miPayRoleUserNum', checked: false },
      { name: '新创角充值金额（中间件）', key: 'miNatureTimeNewRoleMoney', checked: false },
      { name: '新创角回款率（中间件）', key: 'miNatureTimeNewRoleRoi', checked: false },
      { name: '总流水（中间件）', key: 'miTotalMoney', checked: false }
    ]
  },

  {
    name: '留存/LTV',
    items: [
      { name: '创角次留', key: 'createRoleRetain2d', checked: false },
      { name: '创角3留', key: 'createRoleRetain3d', checked: false },
      { name: '创角7留', key: 'createRoleRetain7d', checked: false },
      { name: '创角30留', key: 'createRoleRetain30d', checked: false },
      { name: '创角1日LTV', key: 'createRoleLtv1d', checked: false },
      { name: '创角3日LTV', key: 'createRoleLtv3d', checked: false },
      { name: '创角7日LTV', key: 'createRoleLtv7d', checked: false },
      { name: '创角30日LTV', key: 'createRoleLtv30d', checked: false }
    ]
  }
]

export const promotionAuthList = [
  {
    name: '基础数据',
    items: [
      { name: '投放计划名称', key: 'planName', checked: true, disabled: true },
      { name: '新建时间', key: 'launchTime', checked: false },
      { name: '媒体', key: 'mediaName', checked: false },
      { name: '账号', key: 'adAccountName', checked: false },
      { name: '游戏', key: 'gameName', checked: false },
      { name: '激活数', key: 'activeNum', checked: false },
      { name: '注册数', key: 'registerNum', checked: false },
      { name: '创角数', key: 'createRoleNum', checked: false },
      { name: '总流水', key: 'totalMoney', checked: false }
    ]
  }

]

export const tableCols = [
  { title: '用户ID', key: 'id', width: 70 },
  { title: '用户名', key: 'name', width: 140 },
  { title: '指标权限', key: 'privilegeText' },
  { title: '状态', key: 'statusText', width: 100 },
  { title: '备注', key: 'remark' },
  { title: '添加人', key: 'optName', width: 120 },
  { title: '添加时间', key: 'addTime', width: 140 }
]

export const ACCOUNT_STATUS = [
  { label: '启用', value: 1 },
  { label: '禁用', value: 0 }
]
